const fromQueryPlaceDetailsToPlaceDetails = (data) => {
  if (!data) {
    return null;
  }
  return {
    id: data.id,
    city: data.city ?? void 0,
    country: data.country ?? void 0,
    countryCode: data.countryCode ?? void 0,
    postalCode: data.postalCode ?? void 0,
    province: data.province ?? void 0,
    provinceShort: data.provinceShort ?? void 0,
    streetName: data.streetName ?? void 0,
    streetNumber: data.streetNumber ?? void 0
  };
};
export {
  fromQueryPlaceDetailsToPlaceDetails
};
//# sourceMappingURL=fromQueryPlaceDetailsToPlaceDetails.js.map
